<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu 
      :readOnly="isReadOnly"/>
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <button
            class="btn btn-red btn-md input-height-15"
            @click="printWindow()">Print</button>
            <div id="locations-display">
              <div style="padding-left: 0px;width: 98%;font-size: 14px;">

                <div v-if="searchParam.search_purchasing_name || searchParam.search_purchasing_group" style="width: 100%;margin: 10px 0px 5px;border: 1px solid rgb(221, 221, 221);padding: 10px;border-radius: 4px;background-color: #FFF;">
                  <div style="font-weight: bold;width: 6%;padding-left: 5px;float: left;">Filters:</div>
                  <div style="width: 35%;padding-left: 5px;float: left;" v-if="searchParam.search_purchasing_group_name">
                    <span style="font-weight: bold;">Group:</span>
                    {{ searchParam.search_purchasing_group_name.charAt(0).toUpperCase() + searchParam.search_purchasing_group_name.slice(1) }}
                  </div>
                  <div style="padding-left: 5px;float: left;" v-if="searchParam.search_purchasing_name">
                    <span style="font-weight: bold;">Keyword:</span>
                    {{ searchParam.search_purchasing_name.charAt(0).toUpperCase() + searchParam.search_purchasing_name.slice(1) }}
                  </div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                </div>

                <div style="width: 100%;margin: 10px 0px 5px;border: 1px solid rgb(221, 221, 221);padding: 10px;border-radius: 4px;background-color: #FFF;">
                  <div style="padding-left: 5px;width: 100%;font-size: 14px;font-weight: 900;margin-top: 10px; margin-bottom: 10px;">
                      Purchasing History
                  </div>
                  <div style="font-weight: bold;width: 8%;padding-left: 5px;float: left;">Date</div>
                  <div style="font-weight: bold;width: 20%;padding-left: 5px;float: left;">Account</div>
                  <div style="font-weight: bold;width: 12%;padding-left: 5px;float: left;">Group</div>
                  <div style="font-weight: bold;width: 20%;padding-left: 5px;float: left;">Subscription Type</div>
                  <div style="font-weight: bold;width: 18%;padding-left: 5px;float: left;"># of Mentors Allowed</div>
                  <div style="font-weight: bold;width: 8%;padding-left: 5px;float: left; text-align: center;">Price</div>
                  <div style="font-weight: bold;width: 8%;padding-left: 5px;float: left; text-align: center;">Expiration</div>
                  <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                  <div style="padding-left: 0px;width: 100%;font-size: 14px;" v-for="(pitem, index) in purchasing_history" :key="index">
                    <div style="width: 8%;padding-left: 5px;float: left;">{{ pitem.orderCreatedAt }}</div>
                    <div style="width: 20%;padding-left: 5px;float: left;">{{ pitem.accountName }}</div>
                    <div style="width: 12%;padding-left: 5px;float: left;">{{ pitem.groupName ? pitem.groupName : 'n/a' }}</div>
                    <div style="width: 20%;padding-left: 5px;float: left;">{{ pitem.subscriptionName }}</div>
                    <div style="width: 18%;padding-left: 5px;float: left;">{{ "Up to " + pitem.maxMentors }}</div>
                    <div style="width: 8%;padding-left: 5px;float: left; text-align: center;">
                        <span class="dollarsign">$</span>{{ pitem.price }}/Year
                    </div>
                    <div style="width: 8%;padding-left: 5px;float: left; text-align: center;">{{ pitem.expirationDate | formatOrderExpired }}</div>
                    <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                  </div>
                  <div v-if="purchasing_history.length === 0" style="color: #dc3545; font-weight: bold; text-align:center; margin: 10px;">No Purchasing History Found</div>
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import UserMenu from '../shared/user_menu.vue';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import { store } from '../../store/store';

export default {
        data() {
          return {
            searchParam: '',
            search_purchasing_group_name: '',
            purchasing_history: [],
            isReadOnly: false,
          }
        },
        components: {
            UserMenu,
            EnterpriseAdminSidebarMenu,
        },
        methods: {
          printWindow: function () {
            var printContents = document.getElementById('locations-display').innerHTML;
            var NewWin = window.open("", "PlatformReport");
            NewWin.document.write(printContents);
            NewWin.document.close();
            NewWin.print();
            NewWin.close();
          },
        },
        mounted() {
        },
        created() {
            this.searchParam = this.$store.getters.getSearchPurchasingHistory;
            this.search_purchasing_group_name = this.searchParam.search_purchasing_group_name;
            var params = {};
            if (this.searchParam.search_purchasing_group) {
                params.search_purchasing_group = this.searchParam.search_purchasing_group; 
            }
            if (this.searchParam.search_purchasing_name) {
                params.search_purchasing_name = this.searchParam.search_purchasing_name; 
            }
            axios('/enterprise-admin/purchase-history',
            {
                method: 'POST',
                data: {
                    search_params: params,
                }
            })
            .then(response => {
                this.loading = false;
                this.purchasing_history = response.data.purchasing_history;
            })
            .catch(() => {
            });

            if (this.$store.state.enterprise_type === 'Readonly') {
              this.isReadOnly = true;
            } else {
              if (this.$store.state.switch_admin_enterprise_isreadonly) {
                this.isReadOnly = true;
              } else {
                this.isReadOnly = false;
              }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/print_enterprise_purchasing.vue